export const iconFontAwesomeEditingGripLines = (
	<i className="fa-solid fa-grip-lines"></i>
);
